import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { unwrap } from '../lib/api-envelope';
import { LOAD_FAILURE_QUERY_OPTIONS } from '../lib/load-failure';
import type { DashboardLayout } from '../types/dashboard-layout';

/** The one key for GET /dashboard/layout. Settings invalidates it on save and on reset. */
export const DASHBOARD_LAYOUT_QUERY_KEY = ['dashboard-layout'] as const;

export function useDashboardLayout() {
  return useQuery({
    queryKey: DASHBOARD_LAYOUT_QUERY_KEY,
    queryFn: () => api.dashboard.layout().then((r) => unwrap<DashboardLayout>(r.data)),
    staleTime: 60_000,
    ...LOAD_FAILURE_QUERY_OPTIONS,
  });
}
